import { appCoreApi } from './generated/appCore';
import { trackEvent } from '../../utils/appAnalyticsUtils';
import { EVENT_TYPE } from '../../constants';

export const appCore = appCoreApi.enhanceEndpoints({
  endpoints: {
    // Track share leader profile events
    appCoreLeadersShareCreate: {
      async onQueryStarted(arg, { queryFulfilled }) {
        await queryFulfilled;
        trackEvent(EVENT_TYPE.SHARE_EXEC_PROFILE);
      },
    },
    appCoreLeadersAdminShareLeaderCreate: {
      invalidatesTags: ['api', 'OrgSharedLeaderGrant'],
      async onQueryStarted(arg, { queryFulfilled }) {
        await queryFulfilled;
        trackEvent(EVENT_TYPE.SHARE_EXEC_PROFILE);
      },
    },
    // Track revoke events (user's own grants)
    appCoreSharedLeadersRevokePartialUpdate: {
      async onQueryStarted(arg, { queryFulfilled }) {
        await queryFulfilled;
        trackEvent(EVENT_TYPE.REVOKE_EXEC_PROFILE);
      },
    },
    // Track org-wide revoke events (support map)
    appCoreOrgSharedLeadersRevokePartialUpdate: {
      async onQueryStarted(arg, { queryFulfilled }) {
        await queryFulfilled;
        trackEvent(EVENT_TYPE.REVOKE_EXEC_PROFILE);
      },
    },
  },
});
